// @flow

import React from 'react';
import _ from 'lodash/fp';
import ModalDialog from '../ModalDialog/ModalDialog';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import {getUrl} from '../../containers/PurchaseOrderReportContainer/PurchaseOrderReportContainer';
import booleanValues from '../../booleanValues';

export type Props = {
  onClose: Function,
  order: any,
  suppliers: any[],
  filter: {
    includePlans: boolean,
    supplierId: ?number,
  },
  updateFilter: Function,
};

const PurchaseReportDialog = ({
  onClose,
  order,
  suppliers,
  filter,
  updateFilter,
}: Props) => (
  <div>
    <ModalDialog
      onClose={onClose}
      className="PurchaseReportDialog"
      show={true}>
      <h4>Inköpsrapport</h4>
      <div className="row">
        <div className="column">
          <SelectFormInput
            input={{
              value: filter.supplierId,
              onBlur: _.noop,
              onChange: supplier => updateFilter(supplier ? supplier.id : null, filter.includePlans),
            }}
            placeholder="Välj leverantör"
            meta={{}}
            valueKey="id"
            labelKey="name"
            multi={false}
            options={suppliers}
            clearable={true} />
        </div>
      </div>
      <div className="row">
        <div className="column">
          <SelectFormInput
            input={{
              value: !!filter.includePlans,
              onBlur: _.noop,
              onChange: includePlans => updateFilter(filter.supplierId, includePlans ? includePlans.value : false),
            }}
            label="Inkludera ritningar"
            meta={{}}
            valueKey="value"
            labelKey="label"
            clearable={false}
            options={booleanValues} />
        </div>
      </div>
      <a
        href={getUrl(order.apartment.projectId, order.apartmentId, filter.supplierId, true, filter.includePlans)}
        onClick={() => {
          onClose();
          return true;
        }}
        target="_blank"
        className="expanded button success">
        Ladda ner
      </a>
      <button
        type="button"
        className="expanded button"
        onClick={onClose}>
        Stäng
      </button>
    </ModalDialog>
  </div>
);

export default PurchaseReportDialog;



// WEBPACK FOOTER //
// ./src/components/PurchaseReportDialog/PurchaseReportDialog.js